const ROOT_TELEMETRY_KEY = 'magazine';

export const EMPTY_KEY = `${ROOT_TELEMETRY_KEY}.empty`;
export const SUCCESS_KEY = `${ROOT_TELEMETRY_KEY}.success`;

export const EMPTY_NEWS_KEY = `${ROOT_TELEMETRY_KEY}.emptyNews`;
export const EMPTY_ARTICLES_KEY = `${ROOT_TELEMETRY_KEY}.emptyArticles`;
export const EMPTY_BLOGS_KEY = `${ROOT_TELEMETRY_KEY}.emptyBlogs`;
export const EMPTY_QUESTIONS_KEY = `${ROOT_TELEMETRY_KEY}.emptyQuestions`;
